import { render, staticRenderFns } from "./PackingListsView.vue?vue&type=template&id=981bd220&scoped=true&"
import script from "./PackingListsView.vue?vue&type=script&lang=js&"
export * from "./PackingListsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "981bd220",
  null
  
)

export default component.exports